// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1a_ND","resendInfoText":"OnGoingPaymentBox_resendInfoText__Z5HKB"};